import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CustomIconButtonV2 from "../../../../components/CustomIconButtonV2";
import CustomText from "../../../../components/CustomText";
import { getFontSize, getFontWeight } from "../../../../components/CustomText";
import Carousel from "react-elastic-carousel";
import Image from "../../../../../assets";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import useMediaQuery from "@material-ui/core/useMediaQuery";
// import * as productSelector from "../../../../../common/selectors/product";
import _ from "lodash";
import Zoom from "@material-ui/core/Zoom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  carouselContainer: {
    margin: 10,
    flexGrow: 1,
    maxHeight: 200,
  },
  media: {
    height: 180,
    [theme.breakpoints.down("sm")]: {
      height: 90,
    },
    [theme.breakpoints.down("xs")]: {
      height: 120,
    },
    objectFit: "cover",
  },
  dateTextStyle: {
    [theme.breakpoints.down("sm")]: {
      ...getFontSize("xxsmall"),
    },
    ...getFontSize("small"),
    fontWeight: "bold",
  },
  titleTextStyle: {
    [theme.breakpoints.down("xs")]: {
      ...getFontSize("xxsmall"),
    },
    ...getFontSize("Medium"),
    // ...getFontWeight("800"),
  },
  arrowContainer: {
    borderRadius: 25,
    marginRight: "-4%",
    backgroundColor: "white",
    [theme.breakpoints.down("xs")]: {
      width: 30,
      height: 30,
    },
    width: 50,
    height: 50,
    justifySelf: "center",
    alignSelf: "center",
    " &:focus ": {
      outline: "none",
      backgroundColor: "white",
    },
  },
  paginationContainer: {
    display: "flex",
  },
  dotContainer: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: "white",
    justifyContent: "space-around",
    alignItems: "center",
  },
  headerTextStyle: {
    ...getFontSize("large"),
    ...getFontWeight("800"),
    marginBottom: 10,
  },
  titleContainer: {
    [theme.breakpoints.down("xs")]: {
      height: 60,
    },
    height: 100,
    marginTop: "2%",
    marginBottom: "2%",
  },
}));

const items = [
  {
    id: 1,
    img: Image.corona_banner,
    date: "19 March 2020",
    desc: "Coronavirus Life Insurance Coverage",
  },
  {
    id: 2,
    img: Image.savings_banner,
    date: "18 March 2020",
    desc: "5 Rules to Save Money for Single Women",
  },
  {
    id: 3,
    img: Image.carinsurance_banner,
    date: "4 February 2020",
    desc: "30% off Car Insurance Promotion",
  },
  {
    id: 4,
    img: Image.corona_banner,
    date: "19 March 2020",
    desc: "Coronavirus Life Insurance Coverage",
  },
  {
    id: 5,
    img: Image.savings_banner,
    date: "19 March 2020",
    desc: "Coronavirus Life Insurance Coverage",
  },
];

const responsive = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 2 },
  { width: 768, itemsToShow: 3 },
  { width: 1200, itemsToShow: 4 },
];

const CarouselBanner = ({ data, getNewsAndHighlights }) => {
  const classes = useStyles();
  const matches = useMediaQuery("(max-width: 599px)");

  // getNewsAndHighlights.map((item,index)=>{
  //   console.log("item",getNewsAndHighlights)
  // })
  const promotionList = [];

  const renderArrowButton = ({ type, onClick, isEdge }) => {
    return (
      <CustomIconButtonV2
        onClick={onClick}
        disabled={isEdge}
        style={classes.arrowContainer}
        edge="start"
        size="small"
      >
        {type === "PREV" ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />}
      </CustomIconButtonV2>
    );
  };

  const renderPagination = ({ pages, activePage, onClick }) => {
    return (
      <div className={classes.paginationContainer}>
        {pages.map((page) => {
          const isActivePage = activePage === page;
          return (
            <div
              key={page}
              onClick={() => onClick(page)}
              activePage={isActivePage}
              className={classes.dotContainer}
            />
          );
        })}
      </div>
    );
  };

  const onClickUrl = (index1) => {
    if (!_.isEmpty(promotionList) && Array.isArray(promotionList)) {
      promotionList.map((item, index) => {
        if (index1 === index) {
          window.open(item.Promotion_Url);
        }
      });
    }
  };

  return (
    <div className={classes.root}>
      {/* <Zoom
            in={true}
            style={{ transformOrigin: "0 0 0", transitionDelay: "600ms" }}
            {...(true ? { timeout: 600 } : {})}
          >
            <CustomText design={classes.headerTextStyle}>
        News and Highlights
      </CustomText>
          </Zoom> */}

      <Carousel
        breakPoints={responsive}
        enableAutoPlay={matches}
        pagination={false}
        renderArrow={renderArrowButton}
        showArrows={!matches}
      >
        <Zoom
          //key={index}
          in={true}
          style={{ transformOrigin: "0 0 0", transitionDelay: "600ms" }}
          {...(true ? { timeout: 600 } : {})}
        >
          <Card
            className={classes.carouselContainer}
            style={{ outline: "none" }}
            //onClick={() => onClickUrl(index)}
          >
            <CardActionArea style={{ outline: "none" }}>
              <CardMedia
                className={classes.media}
                image={Image.renewalBanner}
              />
              {/* <CardContent style={{ maxHeight: 300 }}>
                <CustomText design={classes.dateTextStyle}>
                 a
                </CustomText>
                <div className={classes.titleContainer}>
                  <CustomText design={classes.titleTextStyle}>
                   b
                  </CustomText>
                </div>
              </CardContent> */}
            </CardActionArea>
          </Card>
        </Zoom>
      </Carousel>
    </div>
  );
};

export default CarouselBanner;
